export default __webpack_public_path__ + "media/products/wepresent-bd4783f0.png";